import { useContext } from "react";
import { I18nContext } from "./context";
import { translations, type TranslationKey } from "./translations";

export function useTranslation() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useTranslation must be used within I18nProvider");

  const { locale, setLocale } = ctx;
  const t = (key: TranslationKey): string => translations[locale][key] ?? key;
  const dir = locale === "ar" ? "rtl" : "ltr";

  return { t, locale, setLocale, dir } as const;
}
